import { useContext } from 'react'
import { useParams } from 'react-router-dom'

import styled from 'styled-components'

import { Button } from 'core/components'

import { AuthContext } from 'providers/auth'

import { AuthLayout } from './layout'

function AuthModule() {
  const { key } = useParams()
  const { signIn, signUp, loading } = useContext(AuthContext)

  const handleSignIn = async () => {
    try {
      await signIn(key)
    } catch (error) {
      // Erro ao iniciar login
    }
  }

  const handleSignUp = async () => {
    try {
      await signUp(key)
    } catch (error) {
      // Erro ao iniciar cadastro
    }
  }

  return (
    <AuthLayout>
      <Container>
        <Title>Bem-vindo ao Toty</Title>
        <Subtitle>Faça login para acessar sua conta</Subtitle>
        
        <Button 
          color="primary" 
          onClick={handleSignIn}
          loading={loading}
          disabled={loading}
        >
          Entrar
        </Button>
        <Button 
          color="primary"
          variant="outline"
          onClick={handleSignUp}
          loading={loading}
          disabled={loading}
        >
          Criar conta
        </Button>
      </Container>
    </AuthLayout>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  width: 100%;
  max-width: 400px;
  padding: 0 1rem;
`

const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: bold;
  color: #000000;
  text-align: center;
  margin: 0;
`

const Subtitle = styled.p`
  font-size: 0.875rem;
  color: #666666;
  text-align: center;
  margin: 0;
`

export { AuthModule }
